// React
import { memo, useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";

// Helpers
import { classNames } from "helpers";

// Servisni sloj
import { uploadFleetDocumentAPI } from "services/api/fleet/vehicles/documents/api";
import { FleetDocumentUpload } from "services/api/fleet/vehicles/documents/types";

// UI
import { Loader } from "ui/components/Loader";

import { InvoiceIncomingFileDropProps } from "./types";

/**
 * Odabir datoteka na lijevoj polovici obrasca, na mjestu na kojem poslije stoji sam dokument —
 * isti prazan okvir kao kod fotografija štete. Nije zaseban modal jer bi tada korisnik imao dva
 * podnožja sa spremanjem i zatvaranjem; obrada kreće čim se datoteke pošalju.
 */
const InvoiceIncomingFileDrop: React.FC<InvoiceIncomingFileDropProps> = (props) => {
  const { onUploaded, isBusy, busyText } = props;

  const [isUploading, setIsUploading] = useState<boolean>(false);

  const handleDrop = useCallback(
    async (newFiles: File[]) => {
      if (newFiles.length === 0) return;

      setIsUploading(true);

      try {
        const uploaded: FleetDocumentUpload[] = await uploadFleetDocumentAPI(newFiles);
        onUploaded(uploaded);
      } catch {
        // greška se prikazuje kroz snackbar
      }

      setIsUploading(false);
    },
    [onUploaded]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop: handleDrop });

  const isWorking = isUploading || isBusy;

  return (
    <div className="h-full w-full p-5 flex flex-col">
      <div
        {...getRootProps()}
        className={classNames(
          "flex-1 flex flex-col items-center justify-center border-2 border-dashed border-blue-300 rounded-sm p-8 cursor-pointer transition-colors",
          isDragActive ? "bg-blue-50" : "bg-slate-50 hover:bg-blue-50"
        )}
      >
        <input {...getInputProps()} />

        {isWorking ? (
          <>
            <Loader isLoading={true}>{null}</Loader>
            {busyText && <p className="text-sm text-slate-500 mt-3">{busyText}</p>}
          </>
        ) : (
          <>
            <img src="/media/images/upload.svg" alt="" className="w-40 h-40 mb-4 opacity-60" />
            <p className="text-sm font-medium text-slate-700 mb-1">
              Učitajte račune za automatsko čitanje
            </p>
            <p className="text-xs text-slate-400">
              Kliknite ovdje ili povucite PDF, sliku ili ZIP s više računa
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default memo(InvoiceIncomingFileDrop);
